import { css, useTheme } from '@emotion/react'
import { AboutUsQuery } from '@graphql-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as React from 'react'
import { maxWidth } from 'src/themes'
import { ScrollAnimation } from './ScrollAnimation'

type Staff = Pick<
	AboutUsQuery['staff']['nodes'][number],
	| 'profileImgSharp'
	| 'name'
	| 'title'
	| 'specialities'
	| 'description'
	| 'available_countries'
>
function StaffComponent({ staff }: { staff: Staff }) {
	const theme = useTheme()

	return (
		<div
			css={css`
				width: 50%;
				padding: 2rem;
				box-sizing: border-box;

				${maxWidth[2]} {
					width: 100%;
				}
			`}>
			<div
				css={css`
					width: 250px;
				`}>
				<ScrollAnimation animateIn='fadeInLeft'>
					<GatsbyImage
						css={css`
							border-radius: 50%;
						`}
						image={
							staff.profileImgSharp?.childImageSharp
								?.gatsbyImageData
						}
						alt={staff.name}
					/>
				</ScrollAnimation>
			</div>
			<div
				css={css`
					flex: 1;
					span.fi {
						margin-right: 0.3rem;
					}
				`}>
				<ScrollAnimation animateIn='fadeInRight'>
					<hgroup>
						<h3
							css={css`
								font-size: 2rem;
								margin-top: 0.5rem;
								margin-bottom: 0.5rem;
							`}>
							{staff.name}
						</h3>
						<h4
							css={css`
								margin-top: 0.5rem;
								margin-bottom: 0.5rem;
							`}>
							{staff.available_countries?.map((country) => (
								<span
									key={country}
									className={`fi fi-${country}`}></span>
							))}{' '}
							{staff.title}
						</h4>
					</hgroup>
					{staff.specialities?.map((specialty) => (
						<div
							css={css`
								display: inline-block;
								padding: 0.5rem 1rem;
								margin: 0.5rem;
								background-color: ${theme.fullTimeColor};
								border-radius: 1rem;
							`}
							key={specialty}>
							{specialty}
						</div>
					))}
					<p>{staff.description}</p>
				</ScrollAnimation>
			</div>
		</div>
	)
}

export default StaffComponent
